export default "__VITE_ASSET__DN3rsXW5__ 720w";